<template>
  <GoogleMaps :config="config" />
</template>

<script>
import GoogleMaps from "../../components/GoogleMaps/GoogleMaps.vue";

export default {
  name: "app",
  components: {
    GoogleMaps
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
